// export default function() {
//   ;(function() {
//     const s = document.getElementsByTagName('script')[0]
//     const b = document.createElement('script')
//     b.type = 'text/javascript'
//     b.id = 'CookieConsent'
//     b.setAttribute('data-culture', 'EN')
//     b.src = 'https://policy.app.cookieinformation.com/uc.js'
//     s.parentNode.insertBefore(b, s)
//   })()

//   console.log('Cookie Information installed')
// }

/* global CookieInformation */

// export default function() {
//   if (process.client) {
//     window.dataLayer = window.dataLayer || [];
//     window.dataLayer.push({
//       ad_storage: 'denied',
//       analytics_storage: 'denied',
//       ad_user_data: 'denied',
//       ad_personalization: 'denied'
//     });
//     (function() {
//       const s = document.getElementsByTagName('script')[0];
//       const b = document.createElement('script');
//       b.type = 'text/javascript';
//       b.id = 'CookieConsent';
//       b.setAttribute('data-culture', 'EN');
//       b.src = 'https://policy.app.cookieinformation.com/uc.js';
//       s.parentNode.insertBefore(b, s);
//     })();

//     console.log('Cookie Information installed');
//   }
// }

export default function() {
  if (process.client) {
    // Ensure dataLayer exists
    window.dataLayer = window.dataLayer || [];

    // Define gtag function if not already defined
    window.gtag =
      window.gtag ||
      function() {
        window.dataLayer.push(arguments);
      };

    // Set default consent to denied
    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      wait_for_update: 500
    });

    // Optional: additional settings from guide
    window.gtag('set', 'ads_data_redaction', true);
    window.gtag('set', 'url_passthrough', true);

    // Inject CookieInformation script
    (function() {
      const s = document.getElementsByTagName('script')[0];
      const b = document.createElement('script');
      b.type = 'text/javascript';
      b.id = 'CookieConsent';
      b.setAttribute('data-culture', 'EN');
      b.setAttribute('data-gcm-version', '2.0'); // добавил по гайду
      b.src = 'https://policy.app.cookieinformation.com/uc.js';
      s.parentNode.insertBefore(b, s);
    })();

    console.log('Cookie Information installed');
  }
}
